import React from 'react';

function OrderAddress(props) {
  const {
    dataLocale,
    view,
    address: {
      firstName,
      lastName,
      email,
      addressline1,
      addressline2,
      city,
      landmark,
      state,
      postcode,
      country,
      phoneCode,
      phone,
    },
  } = props;
  const { DELIVERY_ADDRESS, INDIA } = dataLocale;
  return (
    <div
      className={`text-capitalize ${
        view === 'desktop'
          ? 'desktop flex-basis-88 line-height-22'
          : 'lh-22 bg-color_off_white pd-l15 pd-r15 pd-t20 pd-b20 mr-t4 mr-b4'
      }`}
      data-testid="orderAddress"
    >
      <div
        className={`${
          view === 'desktop'
            ? 'font-bold fs14 margin-b20'
            : 'fw700 fsp16 mr-b10 text-color_grey_black'
        }`}
      >
        {DELIVERY_ADDRESS}:
      </div>
      <div
        className={`${
          view === 'desktop'
            ? 'text-color-33 font-medium'
            : 'fsp14 text-color_grey_black mr-b12 fw700'
        }`}
      >
        {firstName} {lastName}
      </div>
      <div
        className={`complete-address ${
          view === 'desktop'
            ? 'fs14 margin-t5 margin-b20 text-color-grey'
            : 'fsp14 mr-b10 text-color_grey_black'
        }`}
      >
        {addressline1 ? <div>{addressline1},</div> : ''}
        {addressline2 ? <div>{addressline2},</div> : ''}
        {landmark ? <div>{landmark},</div> : ''}
        {city ? <span>{city}</span> : ''}
        {postcode ? (
          <span>
            {city ? ' - ' : ''}
            {postcode},
          </span>
        ) : (
          ''
        )}
        <br />
        {state ? <span>{state}, </span> : ''}
        {country ? <span>{country === 'IN' ? INDIA : country}</span> : ''}
      </div>
      <div
        className={`text-lowercase ${
          view === 'desktop' ? 'text-color-grey fs14' : 'fsp14 text-color_grey_black'
        }`}
      >
        {email}
      </div>
      {phoneCode && phone && (
        <div
          className={`${
            view === 'desktop' ? 'fs14 text-color-grey' : 'fsp14 text-color_grey_black'
          }`}
        >
          {phoneCode}-{phone}
        </div>
      )}
    </div>
  );
}

export default OrderAddress;
